module.exports = {
  OperationFailed: 'การดำเนินการล้มเหลว',
  SelectTime: 'เลือกเวลา',
  FeeRefund: '(มีค่าธรรมเนียมการยกเลิก)',
  TheHasExpiredNoCreated: 'สัญญาของหน่วยงานที่มอบหมายสิ้นสุดแล้ว ไม่สามารถสร้างธุรกิจใหม่ได้',
  DueCannotBePrintedNeeded: 'เนื่องจากเกินขีดจำกัดเครดิต ตั๋วนี้ถูกล็อคแล้ว จะไม่สามารถพิมพ์หรือใช้ EDI ได้ กรุณาติดต่อผู้ดูแลเพื่อปลดล็อกเมื่อจำเป็น!',
  ItPrintedPleaseContactUnlock: 'ถูกล็อคแล้ว ไม่สามารถพิมพ์ได้ กรุณาติดต่อผู้ดูแลเพื่อปลดล็อก!',
  AttachmentContentIsTooLarge: 'เนื้อหาของไฟล์แนบมีขนาดใหญ่เกินไป',
  Unknown: 'ไม่ทราบรายละเอียด',
  YourWeightAndVolumeTo: 'สินค้าของคุณเคยเข้าร่วมการเปรียบเทียบข้อมูลแล้ว การบรรจุภัณฑ์อัตโนมัติจะอัปเดตข้อมูลจำนวนและน้ำหนักของตั๋วนี้และตั๋วหลักที่เกี่ยวข้อง',
  Tip: 'แจ้งเตือน',
  GotIt: 'เข้าใจแล้ว',
  AddNew: 'เพิ่มใหม่',
  PleaseSelectTheSpecifiedData: 'กรุณาเลือกข้อมูลที่กำหนด',
  LicenseOfLadingNumberEmpty: 'หมายเลขทะเบียนรถและหมายเลขใบตราส่งไม่สามารถเว้นว่างได้',
  IntegratedLogisticsCargoDetails: 'รายละเอียดสินค้าด้านลอจิสติกส์แบบบูรณาการ',
  PleaseAPieceOfData: 'กรุณาเลือกข้อมูลหนึ่งรายการ!',
  Mbl: 'หมายเลข CMR'
}
